export default function ProxyIcon() {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.23057 0.447214C5.79363 0.165686 6.45637 0.165686 7.01943 0.447214L10.5194 2.19721C11.197 2.536 11.625 3.22852 11.625 3.98607V7.01393C11.625 7.77148 11.197 8.464 10.5194 8.80279L7.01943 10.5528C6.45637 10.8343 5.79363 10.8343 5.23057 10.5528L1.73057 8.80279C1.05301 8.464 0.625 7.77148 0.625 7.01393L0.625 3.98607C0.625 3.22852 1.053 2.536 1.73057 2.19721L5.23057 0.447214Z"
        fill="#36CFC9"
      />
      <path
        d="M1.95208 5.05481C2.19404 4.85912 2.63064 4.56518 3.06151 4.35905C3.95159 3.93323 5.15775 3.78321 6.54036 4.78113C7.51988 5.48812 8.32308 5.36678 8.91568 5.08824C9.40662 4.85749 10.2385 4.0539 10.4654 3.80078L10.4673 5.93138C10.2227 6.13355 9.8246 6.42163 9.38656 6.62752C8.48795 7.04989 7.2564 7.20292 5.87207 6.20376C4.89083 5.49553 4.11464 5.61981 3.53971 5.89486C3.03059 6.13843 2.3635 6.53933 1.94727 7.03789L1.95208 5.05481Z"
        fill="#E6FFFB"
      />
    </svg>
  );
}
